import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  CashierTradingAccount,
  CashierTradingAccountMargin,
} from "@/api/cashier";

const initialState: {
  selectedAccount: CashierTradingAccount | undefined;
  selectedToAccount: CashierTradingAccount | null;
  transfer: {
    selectedAccount: CashierTradingAccountMargin | undefined;
    selectedToAccount: CashierTradingAccountMargin | null;
  };
} = {
  selectedAccount: undefined,
  selectedToAccount: null,
  transfer: {
    selectedAccount: undefined,
    selectedToAccount: null,
  },
};

export const accountSlice = createSlice({
  name: "account",
  initialState: initialState,
  reducers: {
    setSelectedAccount: (
      state,
      action: PayloadAction<CashierTradingAccount>
    ) => {
      state.selectedAccount = action.payload;
    },
    setSelectedToAccount: (
      state,
      action: PayloadAction<CashierTradingAccount | null>
    ) => {
      state.selectedToAccount = action.payload;
    },
    setSelectedTransferAccount: (
      state,
      action: PayloadAction<CashierTradingAccountMargin>
    ) => {
      state.transfer.selectedAccount = action.payload;
    },
    setSelectedTransferToAccount: (
      state,
      action: PayloadAction<CashierTradingAccountMargin | null>
    ) => {
      state.transfer.selectedToAccount = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSelectedAccount,
  setSelectedToAccount,
  setSelectedTransferAccount,
  setSelectedTransferToAccount,
} = accountSlice.actions;

export default accountSlice.reducer;
